import React from "react";
import "./Emails.scss";

// Types
import { CurrentSegmentComponentProps } from "../SettingsTypes";

// Hooks
import { useTranslation } from "react-i18next";

// Components
import { IonNote } from "@ionic/react";
import SubTitle from "../../../../components/Admin/Settings/SubTitle";
import { InputFactory } from "../../../../components/Factories/Input";

export default function EmailsSegment(props: CurrentSegmentComponentProps) {
  const { t } = useTranslation();
  const { formData, updateFormData, errors } = props;

  const signatureField = React.useRef<HTMLInputElement>(null);
  const supportEmailField = React.useRef<HTMLInputElement>(null);
  const fromName = React.useRef<HTMLInputElement>(null);
  const fromEmail = React.useRef<HTMLInputElement>(null);

  return (
    <div className="page--admin--settings--emails">
      <p>
        {t("emailsSettingsTabExplainer1")}
        <br /> {t("emailsSettingsTabExplainer2")}
      </p>

      <SubTitle text={t("emailVariables")} actionText={t("clearAll") as string} actionHandler={resetFields} />

      <div className={`input__container input__container--type-text ${errors?.["email.text_from_name"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.email?.text_from_name}
          name="email.text_from_name"
          label={t("fromName") + " *"}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
          inputRef={fromName}
        />

        {errors?.["email.text_from_name"] && <IonNote color="danger">{errors?.["email.text_from_name"]}</IonNote>}
      </div>

      <div className={`input__container input__container--type-text ${errors?.["email.email_from_address"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.email?.email_from_address}
          name="email.email_from_address"
          label={t("fromName") + " *"}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
          inputRef={fromEmail}
        />

        {errors?.["email.email_from_address"] && <IonNote color="danger">{errors?.["email.email_from_address"]}</IonNote>}
      </div>

      <div className={`input__container input__container--type-text ${errors?.["email.text_signature"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.email?.text_signature}
          name="email.text_signature"
          label={t("emailSignature") + " *"}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
          inputRef={signatureField}
        />

        {errors?.["email.text_signature"] && <IonNote color="danger">{errors?.["email.text_signature"]}</IonNote>}
      </div>

      <div className={`input__container input__container--type-text ${errors?.["email.email_support"] && "has-error"}`}>
        <InputFactory
          type="text"
          value={formData?.email?.email_support}
          name="email.email_support"
          label={t("supportEmail") + " *"}
          onIonChange={updateFormData}
          className={"input__input input-factory__input input-factory__input--type-text"}
          inputRef={supportEmailField}
        />

        {errors?.["email.email_support"] && <IonNote color="danger">{errors?.["email.email_support"]}</IonNote>}
      </div>
    </div>
  );

  function resetFields() {
    updateFormData({
      detail: {
        name: "email.text_signature",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "email.email_support",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "email.text_from_name",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "email.email_from_address",
        value: null,
      },
    });

    if (signatureField.current) {
      signatureField.current.value = "";
    }

    if (supportEmailField.current) {
      supportEmailField.current.value = "";
    }

    if (fromName.current) {
      fromName.current.value = "";
    }

    if (fromEmail.current) {
      fromEmail.current.value = "";
    }
  }
}
